/**
 * 横スクロール機能
 * .side-scroll-wrapper要素に対して以下の機能を提供:
 * 1. マウスホイールで横スクロール（縦スクロールを横スクロールに変換）
 * 2. マウスドラッグで横スクロール（タブレットのような操作感）
 */

// 定数定義
const SELECTOR = ".side-scroll-wrapper";
const DRAGGING_CLASS = "is-dragging";

document.addEventListener("DOMContentLoaded", function () {
  const scrollContainer = document.querySelector(SELECTOR);

  if (scrollContainer) {
    // ========================================
    // マウスホイールで横スクロール
    // 縦方向のホイール操作(deltaY)を横スクロール(scrollLeft)に変換
    // ========================================
    scrollContainer.addEventListener("wheel", function (event) {
      if (event.deltaY !== 0) {
        event.preventDefault(); // デフォルトの縦スクロールを防止
        scrollContainer.scrollLeft += event.deltaY;
      }
    });

    // ========================================
    // マウスドラッグで横スクロール
    // タブレットのように掴んでスクロールできる
    // ========================================
    let isDragging = false; // ドラッグ中かどうか
    let startX;             // ドラッグ開始時のマウスX座標
    let scrollLeft;         // ドラッグ開始時のスクロール位置

    // ドラッグ開始
    scrollContainer.addEventListener("mousedown", function (event) {
      isDragging = true;
      scrollContainer.classList.add(DRAGGING_CLASS); // カーソルをgrabbingに変更
      startX = event.pageX - scrollContainer.offsetLeft; // コンテナ内でのX座標
      scrollLeft = scrollContainer.scrollLeft; // 現在のスクロール位置を保存
      event.preventDefault(); // テキスト選択を防止
    });

    // ドラッグ中：マウス移動量に応じてスクロール
    scrollContainer.addEventListener("mousemove", function (event) {
      if (!isDragging) return;
      const x = event.pageX - scrollContainer.offsetLeft; // 現在のX座標
      const walk = x - startX; // 移動量（正:右へ移動, 負:左へ移動）
      scrollContainer.scrollLeft = scrollLeft - walk; // 移動方向と逆にスクロール
    });

    // ドラッグ終了
    scrollContainer.addEventListener("mouseup", function () {
      isDragging = false;
      scrollContainer.classList.remove(DRAGGING_CLASS);
    });

    // 要素外にマウスが出た場合もドラッグ終了
    scrollContainer.addEventListener("mouseleave", function () {
      isDragging = false;
      scrollContainer.classList.remove(DRAGGING_CLASS);
    });
  }
});
